import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  redirect(event) {
    const url = event.target.value
    if (url) {
      // Use full page redirect for new use case page (exits playground)
      if (url.includes('/use_case/new')) {
        window.location.href = url
      } else {
        // Use Turbo for SOP switching within playground
        Turbo.visit(url)
      }
    }
  }
}